export default __webpack_public_path__ + "static/media/MachineStates.485b760c.jpg";